import { createSlice } from "@reduxjs/toolkit";
import mastersuperadminchangePasswordApi from "@custom/rtk-apis/masterSuperAdminProfile/changePassword";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const masterSuperAdminChangePasswordSlice = createSlice({
  name: "masterSuperAdminChangePasswordSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mastersuperadminchangePasswordApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(mastersuperadminchangePasswordApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(mastersuperadminchangePasswordApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default masterSuperAdminChangePasswordSlice.reducer;
